var map = {
	"app/components/impostazioni/impostazioni.module": [
		"./src/app/components/impostazioni/impostazioni.module.ts",
		"impostazioni.module",
		"common"
	],
	"app/components/produttore/produttore.module": [
		"./src/app/components/produttore/produttore.module.ts",
		"produttore.module",
		"common"
	],
	"app/components/smistatore/smistatore.module": [
		"./src/app/components/smistatore/smistatore.module.ts",
		"smistatore.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main